export default "__VITE_ASSET__qNqFrukQ__"